module.exports = __webpack_public_path__ + "src-notif-airbnb.png?3788b7654a64503d2051ac483271ab62";